import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import {
  type QuestionnaireDetailDto,
  questionnaireDetailDtoSchema,
  type SaveQuestionnaireInput,
} from '../schemas/questionnaireSchemas';
import { questionnaireKeys } from './questionnaireKeys';

export function useSaveQuestionnaire(questionnaireId: string | undefined) {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async (body: SaveQuestionnaireInput): Promise<QuestionnaireDetailDto> => {
      const raw = await apiClient
        .put(`api/v1/t/${tenantId}/questionnaires/${questionnaireId}`, { json: body })
        .json();
      return questionnaireDetailDtoSchema.parse(raw);
    },
    onSuccess: (data) => {
      if (questionnaireId) qc.setQueryData(questionnaireKeys.detail(questionnaireId), data);
      qc.invalidateQueries({ queryKey: questionnaireKeys.lists() });
    },
  });
}
